import React from 'react';
import PropTypes from 'prop-types';
import { fetchApi } from 'providers/myRestProvider';
import {fetchEnd, fetchStart, showNotification, refreshView} from 'react-admin';
import Button from '@material-ui/core/Button';
import {connect} from 'react-redux';

class SyncDepositAddressButton extends React.Component {
	static propTypes = {
		done: PropTypes.func,
		record: PropTypes.object,
	};

	handleClick = () => {
		const {record, done, showNotification, refreshView} = this.props;
		this.doRequest(`deposit_addresses/${record.id}/sync`).then(() => {
			showNotification('Wallet is scheduled for sync');
			refreshView();
		}).catch((e) => {
			showNotification(e.message, 'warning')
		}).then(done);
	};

	doRequest(url, data = null) {
		const {fetchStart, fetchEnd} = this.props;
		fetchStart();
		return fetchApi(url, {method: 'POST', body: data}).finally(fetchEnd);
	}

	render() {
		const {record, children} = this.props;
		const {provider} = record;
		if (provider !== 'hive') {
			return null;
		}
		return <Button color="primary" variant="contained" onClick={this.handleClick}>
			{children || 'Sync'}
		</Button>;
	}
}

export default connect(null, {
	showNotification, refreshView, fetchStart, fetchEnd
})(SyncDepositAddressButton);
